declare const siteVars: { ajaxUrl: string };

document.addEventListener('DOMContentLoaded', () => {

    // ─── Canvas Drawer ───────────────────────────────────────────────────────
    const menuToggle   = document.getElementById('mobile-menu-toggle') as HTMLElement | null;
    const canvasDrawer = document.getElementById('canvas-drawer')      as HTMLElement | null;
    const canvasOverlay= document.getElementById('canvas-overlay')     as HTMLElement | null;
    const canvasClose  = document.getElementById('canvas-close')       as HTMLElement | null;

    function openDrawer(): void {
        if (canvasDrawer)  canvasDrawer.style.translate  = '0 0';
        if (canvasOverlay) { canvasOverlay.style.opacity = '1'; canvasOverlay.style.pointerEvents = 'auto'; }
        menuToggle?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer(): void {
        if (canvasDrawer)  canvasDrawer.style.translate  = '-100% 0';
        if (canvasOverlay) { canvasOverlay.style.opacity = '0'; canvasOverlay.style.pointerEvents = 'none'; }
        menuToggle?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    menuToggle?.addEventListener('click', openDrawer);
    canvasClose?.addEventListener('click', closeDrawer);
    canvasOverlay?.addEventListener('click', closeDrawer);

    // ─── Search Modal ─────────────────────────────────────────────────────────
    const searchToggle      = document.getElementById('search-toggle')       as HTMLElement | null;
    const searchModal       = document.getElementById('search-modal')        as HTMLElement | null;
    const searchModalClose  = document.getElementById('search-modal-close')  as HTMLElement | null;
    const searchModalOverlay= document.getElementById('search-modal-overlay')as HTMLElement | null;
    const searchInput       = document.getElementById('search-modal-input')  as HTMLInputElement | null;
    const resultsPanel      = document.getElementById('search-results-panel')as HTMLElement | null;
    const resultsList       = document.getElementById('search-results-list') as HTMLElement | null;
    const loadingEl         = document.getElementById('search-loading')      as HTMLElement | null;
    const emptyEl           = document.getElementById('search-empty')        as HTMLElement | null;
    const hintEl            = document.getElementById('search-hint')         as HTMLElement | null;

    function openSearch(): void {
        if (searchModal) { searchModal.style.opacity = '1'; searchModal.style.pointerEvents = 'auto'; }
        searchToggle?.setAttribute('aria-expanded', 'true');
        setTimeout(() => searchInput?.focus(), 50);
    }

    function closeSearch(): void {
        if (searchModal) { searchModal.style.opacity = '0'; searchModal.style.pointerEvents = 'none'; }
        searchToggle?.setAttribute('aria-expanded', 'false');
        resetResults();
    }

    function resetResults(): void {
        if (resultsPanel) resultsPanel.classList.add('hidden');
        if (hintEl)       hintEl.classList.remove('hidden');
        if (resultsList)  resultsList.innerHTML = '';
        showState('hint');
    }

    function showState(state: 'loading' | 'results' | 'empty' | 'hint'): void {
        if (loadingEl) loadingEl.classList.toggle('hidden', state !== 'loading');
        if (emptyEl)   emptyEl.classList.toggle('hidden',   state !== 'empty');
        if (hintEl)    hintEl.classList.toggle('hidden',    state !== 'hint');
    }

    searchToggle?.addEventListener('click', openSearch);
    searchModalClose?.addEventListener('click', closeSearch);
    searchModalOverlay?.addEventListener('click', closeSearch);

    // ─── AJAX Search ─────────────────────────────────────────────────────────
    let debounceTimer: ReturnType<typeof setTimeout>;

    searchInput?.addEventListener('input', () => {
        const term = searchInput.value.trim();

        clearTimeout(debounceTimer);

        if (term.length < 3) {
            resetResults();
            return;
        }

        resultsPanel?.classList.remove('hidden');
        hintEl?.classList.add('hidden');
        if (resultsList) resultsList.innerHTML = '';
        showState('loading');

        debounceTimer = setTimeout(async () => {
            try {
                const url = new URL(siteVars.ajaxUrl);
                url.searchParams.set('action', 'aparecida_search');
                url.searchParams.set('term', term);

                const res  = await fetch(url.toString());
                const data = await res.json() as Array<{ title: string; url: string; thumb: string; label: string }>;

                if (!data.length) {
                    showState('empty');
                    return;
                }

                showState('results');

                if (resultsList) {
                    resultsList.innerHTML = data.map(item => `
                        <li>
                            <a href="${item.url}" class="flex items-center gap-4 px-5 py-3 hover:bg-gray-50 transition-colors group">
                                <div class="w-16 h-12 rounded-lg overflow-hidden shrink-0 bg-gray-100 flex items-center justify-center">
                                    ${item.thumb
                                        ? `<img src="${item.thumb}" alt="${item.title}" class="w-full h-full object-cover">`
                                        : `<svg class="w-6 h-6 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>`
                                    }
                                </div>
                                <div class="flex-1 min-w-0">
                                    <span class="text-xs font-semibold text-secondary uppercase tracking-wide">${item.label}</span>
                                    <p class="text-gray-800 font-medium text-sm leading-snug mt-0.5 truncate group-hover:text-primary transition-colors">${item.title}</p>
                                </div>
                                <svg class="w-4 h-4 text-gray-300 shrink-0 group-hover:text-primary transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                                </svg>
                            </a>
                        </li>
                    `).join('');
                }
            } catch {
                showState('empty');
            }
        }, 300);
    });

    // ─── Máscara CNPJ ────────────────────────────────────────────────────────
    function maskCNPJ(value: string): string {
        const v = value.replace(/\D/g, '').substring(0, 14);
        return v
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2');
    }

    document.querySelectorAll<HTMLInputElement>('[data-mask="cnpj"]').forEach(input => {
        input.addEventListener('input', () => {
            input.value = maskCNPJ(input.value);
        });
    });

    // ─── Escape fecha tudo ────────────────────────────────────────────────────
    document.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            closeDrawer();
            closeSearch();
        }
    });
});
